import React from "react";

/** ⓘ on the field label only — no hint paragraphs in the form. */
export default function PolicyFieldHint({ title, label = "More info" }) {
  if (!title) return null;
  return (
    <span
      title={title}
      aria-label={label}
      className="inline-flex h-3.5 w-3.5 shrink-0 cursor-help items-center justify-center rounded-full text-[10px] font-semibold leading-none text-[hsl(var(--ds-muted-fg))] hover:text-[hsl(var(--ds-fg))]"
    >
      ⓘ
    </span>
  );
}

export function PolicyHintField({ label, hint, children }) {
  return (
    <div>
      <div className="mb-1 flex items-center gap-1">
        <span className="text-[11px] font-medium text-[hsl(var(--ds-muted-fg))]">{label}</span>
        <PolicyFieldHint title={hint} />
      </div>
      {children}
    </div>
  );
}
